<template>
  <div>
    <data-table :service="ProductService"
                :service-path="servicePath"
                :entity="entity"
                :columns="columns"
                :disablePermissionChecks="true"
                :go-to-details-on-row-click="false"
                :goToAddOnClick="false"
                operations="edit,add,delete"
                @on-edit="onRowEdit"
                @on-add="onRowAdd"
                @on-row-click="onRowEdit"
                ref="table">
      <template slot="name" slot-scope="{row}">
        {{product.name}}
      </template>
      <router-link slot="job_board" slot-scope="{row}" :to="`/job-board/${row.product_job_board.job_board_id}`">
        {{row.product_job_board.name || $t('generic.na')}}
      </router-link>
      <template slot="product_type" slot-scope="{row}">
        {{row.type}}
      </template>
    </data-table>

    <modal :show.sync="showModal" v-if="showModal">
      <product-rule-form :product-rule="currentProductRule"
                         @submit="onSubmitRule">
      </product-rule-form>
    </modal>
  </div>
</template>
<script>
  import ProductService from 'src/services/ProductService'
  import ProductRuleForm from './ProductRuleForm'
  import { entities } from 'src/config/routeTypes'
  export default {
    name: 'products-rule-settings',
    components: {
      ProductRuleForm
    },
    props: {
      product: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        ProductService,
        entity: entities.PRODUCT_RULE,
        currentProductRule: null,
        showModal: false
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('settings.products.labels.name'),
            minWidth: '140px'
          },
          {
            prop: 'job_board',
            label: this.$t('settings.products.labels.job_board'),
            minWidth: '140px',
          },
          {
            prop: 'product_type',
            label: this.$t('settings.products.labels.product_type'),
            minWidth: '140px',
          }
        ]
      },
      servicePath () {
        return `/${this.$route.params.id}/rules?with=product_job_board`
      },
      jobBoards() {
        return this.$store.state.config.jobBoards;
      }
    },
    methods: {
      getJobBoard (jobBoardId) {
        return this.jobBoards.find(j => j.id === jobBoardId) || {};
      },
      onRowAdd() {
        this.currentProductRule = null
        this.showModal = true
      },
      onRowEdit(row) {
        this.currentProductRule = row
        this.showModal = true
      },
      async onSubmitRule(data) {
        let productId = this.$route.params.id;
        if (data.id) {
          await ProductService.updateProductRule(productId, data);
        } else {
          await ProductService.createProductRule(productId, data);
        }
        this.showModal = false
        this.$refs.table.getTableData()
      }
    }
  }
</script>
<style>
</style>
